<!-- Styling classes stolen from the 'object new page' component just to have something up and running... -->
<div class="admin-mass-media-import">
  <app-top-header
    [parent]="parent"
    backRouterLink="/admin"
    backRouterLinkLabel="TRANS__SECTION__ADMIN__TITLE"
    class="admin-header-container"
  ></app-top-header>

  <app-header-and-description
    heading="TRANS__MASS_MEDIA_IMPORT__HEADING"
    description="TRANS__MASS_MEDIA_IMPORT__MEDIA_FOLDER_DESCRIPTION"
  >
    <div class="admin-mass-media-import__container">
      <div class="admin-mass-media-import__top">
        <div class="admin-mass-media-import__section">
          <h4>{{ 'TRANS__MASS_MEDIA_IMPORT__MEDIA_FOLDER' | translate }}</h4>
          <mat-card appearance="outlined">
            <mat-card-content>
              <div class="admin-mass-media-import__create-folder">
                @if (preOperationContainer?.operations?.length) {
                  <ng-container>
                    @for (operation of preOperationContainer.operations; track $index) {
                      <button
                        mat-stroked-button
                        class="admin-mass-media-import__create-folder-button"
                        color="primary"
                        type="button"
                        [disabled]="preOpButtonsDisabled"
                        (click)="openPreProdOperation(operation)"
                      >
                        <i class="{{operation.menu_icon}}"></i>

                        <span class="bold uppercase">
                          {{ operation.menu_title | translate }}
                        </span>
                      </button>
                    }
                  </ng-container>
                }
              </div>

              @if (mediaFolder) {
                <span class="bold admin-mass-media-import__created-folder">
                    <mat-icon>perm_media</mat-icon>
                    <app-object-url [object]="mediaFolder">
                      <span class="object-url-content text-blue">
                        <span>
                          {{ 'TRANS__MASS_IMPORT__MEDIA_FOLDER_NAME' | translate }}
                        </span>

                        : {{mediaFolder.artifact_name}}
                      </span>
                    </app-object-url>
                  </span>
              }
            </mat-card-content>
          </mat-card>
        </div>

        <div class="admin-mass-media-import__section">
          <h4>{{ 'TRANS__MASS_MEDIA_IMPORT__OPTIONS' | translate }}</h4>
          <mat-card appearance="outlined">
            <mat-card-content>
              <mat-checkbox
                [(ngModel)]="checkPublish"
                [disabled]="importButtonDisabled || !mediaFolder"
              >
                <span>{{ 'TRANS__MASS_MEDIA_IMPORT__SET_PUBLISHED' | translate }}</span>
                <span>{{ 'TRANS__MASS_MEDIA_IMPORT__SET_PUBLISHED__HELP_TEXT' | translate }}</span>
              </mat-checkbox>

              <mat-checkbox
                [(ngModel)]="uploadAsAttachments"
                [disabled]="importButtonDisabled || !mediaFolder"
              >
                <span>{{ 'TRANS__MASS_MEDIA_IMPORT__FORCE_ATTACHMENT' | translate }}</span>
                <span>{{ 'TRANS__MASS_MEDIA_IMPORT__FORCE_ATTACHMENT__HELP_TEXT' | translate }}</span>
              </mat-checkbox>
            </mat-card-content>
          </mat-card>
        </div>
      </div>


      <div class="admin-mass-media-import__section admin-mass-media-import__buttons">
        <input
          #fileInput
          type="file"
          (change)="onFileSelect($event)"
          id="uploadFiles"
          multiple="multiple"
          accept="image/*,video/*,audio/*,application/*,.gltf,.glb"
          [disabled]="importButtonDisabled || !mediaFolder"
        >

        <button
          mat-stroked-button
          type="button"
          [disabled]="importButtonDisabled || !mediaFolder"
          color="primary"
          (click)="selectFiles(fileInput)"
        >
          <i class="icon-upload"></i>

          @if (computer) {
            <span class="bold uppercase">
              {{ 'TRANS__IMAGE_SELECTOR__UPLOAD_FILES' | translate }}
            </span>
          }
          @else {
            <span class="bold uppercase">
              {{ 'TRANS__IMAGE_SELECTOR__UPLOAD_IMAGE_AND_CAMERA' | translate }}
            </span>
          }
        </button>
      </div>

      @if (uploadStatus) {
        <hr>

        <mat-card class="admin-card admin-mass-media-import__status">
          <div class="admin-mass-media-import__status-text">
            <ng-container>
              @switch (uploadStatus) {
                @case ('uploading') {
                  <ng-container>
                    <mat-icon class="admin-mass-media-import__icon">
                      cloud_upload
                    </mat-icon>

                    <span>
                      {{ 'TRANS__MASS_MEDIA_IMPORT__UPLOADING' | translate }}
                    </span>
                  </ng-container>
                }

                @case ('uploadFinished') {
                  <ng-container>
                    <mat-icon class="admin-mass-media-import__icon admin-mass-media-import__icon--success">
                      done
                    </mat-icon>

                    <span>
                      {{ 'TRANS__MASS_MEDIA_IMPORT__SUCCESS' | translate }}
                    </span>
                  </ng-container>
                }

                @case ('failed') {
                  <ng-container>
                    <mat-icon class="admin-mass-media-import__icon admin-mass-media-import__icon--failed">
                      close
                    </mat-icon>

                    <div>
                      <div>
                        {{ 'TRANS__MASS_MEDIA_IMPORT__FAILED' | translate }}
                      </div>

                      <div>
                        {{uploadStatusText}}
                      </div>
                    </div>
                  </ng-container>
                }
              }
            </ng-container>
          </div>

          <div class="admin-card admin-mass-media-import__status-bar">
            <mat-progress-bar
              mode="determinate"
              [value]="getUploadProgressPercent()"
            ></mat-progress-bar>

            <span>
              {{ getCompletedUploadsCount() }}/{{ uploadQueue.length }}
            </span>
          </div>
        </mat-card>
      }

      @if (uploadQueue.length) {
        <table
          mat-table
          [dataSource]="uploadQueue"
          aria-label="Import results"
          class="admin-mass-media-import__table"
        >
          <ng-container matColumnDef="fileName">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'TRANS__MASS_MEDIA_IMPORT__FILE_NAME' | translate }}
            </th>

            <td mat-cell *matCellDef="let element">
              <div>
                <ng-container>
                  @switch (element.uploadType) {
                    @case ('image') {
                      <mat-icon>
                        photo_library
                      </mat-icon>
                    }

                    @case ('video') {
                      <mat-icon>
                        smart_display
                      </mat-icon>
                    }

                    @case ('audio') {
                      <mat-icon>
                        library_music
                      </mat-icon>
                    }

                    @case ('attachment') {
                      <mat-icon>
                        description
                      </mat-icon>
                    }

                    @case ('model_3d') {
                      <mat-icon>
                        deployed_code
                      </mat-icon>
                    }

                    @default {
                      <mat-icon>
                        help_outline
                      </mat-icon>
                    }
                  }
                </ng-container>

                <span>
                  {{element.fileName}}
                </span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="statusText">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'TRANS__MASS_MEDIA_IMPORT__IMPORT_STATUS' | translate }}
            </th>

            <td mat-cell *matCellDef="let element">
              @if (element.statusText) {
                <ng-container>
                  {{element.statusText}}@if (element.status) { ({{element.status}})}
                </ng-container>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="ok">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'TRANS__MASS_MEDIA_IMPORT__IMPORT_OK' | translate }}
            </th>

            <td mat-cell *matCellDef="let element">
              <ng-container>
                @switch (element.state) {
                  @case ('uploading') {
                    <div>
                      <mat-progress-spinner
                        mode="indeterminate"
                        diameter="16"
                        strokeWidth="3">
                      </mat-progress-spinner>
                    </div>
                  }

                  @case ('success') {
                    <mat-icon color="primary">
                      check
                    </mat-icon>
                  }

                  @case ('failed') {
                    <mat-icon color="warn">
                      close
                    </mat-icon>
                  }
                }
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="uploadStatus">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'TRANS__MASS_MEDIA_IMPORT__UPLOAD_STATUS' | translate }}
            </th>

            <td mat-cell *matCellDef="let element">
              {{element.uploadStatusText}}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      }
    </div>
  </app-header-and-description>
</div>
